import { z } from "zod";

import { Icon } from "@/client";
import i18n from "@/i18n";
import { httpsUrlSchema } from "./url-navigation-item-schema";

const customUrlNavigationItemSchema = z.object({
  icon: z.nativeEnum(Icon),
  title: z
    .string()
    .min(1, { message: i18n.t("validation.navigationTitleRequired") })
    .trim(),
  visibility: z.string().optional(),
  url: httpsUrlSchema,
  content: z.string(),
});

type CustomUrlNavigationItemFormData = z.infer<
  typeof customUrlNavigationItemSchema
>;

export { customUrlNavigationItemSchema };
export type { CustomUrlNavigationItemFormData };
